import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PaymentOptionsLoadingStatus from '../enums/PaymentOptionsLoadingStatus';
import {changeSelectedPaymentMethod} from '../v2/actions/paymentActions/PaymentSelectionActions';
import selectAvailablePaymentOption from '../v2/actions/paymentActions/selectAvailablePaymentOption';
import getIsUsingExpressCheckout from '../v2/selectors/ExpressSelectors/getIsUsingExpressCheckout';
import getPaymentOptionsLoadingStatus from '../v2/selectors/PaymentOptionSelectors/getPaymentOptionsLoadingStatus';
import {getSelectedPaymentOptionIndex} from '../v2/selectors/PaymentOptionSelectors/getSelectedPaymentOptionIndex';
import {getSettings, isZeroValueOrder} from '../v2/selectors/selectors';

export function ZeroPaymentListener(props) {
  const [selectedExpressOptionIndex, setSelectedExpressOptionIndex] = useState(-1);
  
  useEffect(() => {
    if (props.zeroOrderValue && props.isAPaymentMethodSelected) {
      let isExpress = false;
      if (props.usingExpressCheckout) {
        isExpress = true;
        setSelectedExpressOptionIndex(props.paymentOptionIndex);
      }
      props.changeSelectedPaymentMethod(-1, 'zeroPaymentListener', isExpress);
    } else if ((!props.zeroOrderValue && !props.isAPaymentMethodSelected) && (!props.deferPaymentOptionPreSelection || props.paymentOptionsLoadingStatus !== PaymentOptionsLoadingStatus.LOADING)) {
      if (props.usingExpressCheckout && selectedExpressOptionIndex > -1) {
        props.changeSelectedPaymentMethod(selectedExpressOptionIndex, 'zeroPaymentListener', true);
      } else {
        props.selectAvailablePaymentOption();
      }
    }
  }, [props.zeroOrderValue, props.isAPaymentMethodSelected, props.changeSelectedPaymentMethod, props.deferPaymentOptionPreSelection, props.paymentOptionsLoadingStatus]);
  
  return null;
}

ZeroPaymentListener.propTypes = {
  zeroOrderValue: PropTypes.bool.isRequired,
  usingExpressCheckout: PropTypes.bool.isRequired,
  paymentOptionIndex: PropTypes.number.isRequired,
  isAPaymentMethodSelected: PropTypes.bool.isRequired,
  paymentOptionsLoadingStatus: PropTypes.symbol.isRequired,
  deferPaymentOptionPreSelection: PropTypes.bool.isRequired,
  selectAvailablePaymentOption: PropTypes.func.isRequired,
  changeSelectedPaymentMethod: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const paymentOptionIndex = getSelectedPaymentOptionIndex(state);
  return {
    zeroOrderValue: isZeroValueOrder(state),
    isAPaymentMethodSelected: paymentOptionIndex > -1,
    paymentOptionIndex,
    usingExpressCheckout: getIsUsingExpressCheckout(state),
    paymentOptionsLoadingStatus: getPaymentOptionsLoadingStatus(state),
    deferPaymentOptionPreSelection: getSettings(state).should_defer_payment_option_preselection,
  };
};

const mapDispatchToProps = {changeSelectedPaymentMethod, selectAvailablePaymentOption};

export default connect(mapStateToProps, mapDispatchToProps)(ZeroPaymentListener);
